import { useState, useEffect } from "react";
import api from "@/lib/api";

export default function Legal() {
  const [email, setEmail] = useState("contact@caribbeandrive.com");
  useEffect(() => { api.get("/contact-info").then((r) => { if (r.data?.email) setEmail(r.data.email); }).catch(() => {}); }, []);
  return (
    <div className="section-sand min-h-screen py-16">
      <div className="max-w-3xl mx-auto px-6 bg-white rounded-2xl shadow-card border border-border p-8 sm:p-12 font-body text-muted2 space-y-8">
        <div>
          <h1 className="font-heading font-extrabold text-3xl text-ink mb-4">Mentions légales</h1>
          <p>Caribbean Drive — Marketplace de location de véhicules dans la Caraïbe. Éditeur : Caribbean Drive SAS. Contact : <a href={`mailto:${email}`} data-testid="legal-email" className="text-canard font-semibold">{email}</a>. Hébergement : cloud sécurisé UE.</p>
        </div>
        <div>
          <h2 className="font-heading font-bold text-2xl text-ink mb-3">Conditions Générales de Vente (CGV)</h2>
          <p>Les réservations sont soumises aux conditions de chaque loueur partenaire. Une commission de plateforme de 8% est prélevée sur chaque location. La caution (empreinte bancaire) est définie par le loueur et prise au comptoir lors du retrait. L'annulation est gratuite jusqu'à 24h avant le départ (remboursement automatique). Devise : EUR (€).</p>
        </div>
        <div>
          <h2 className="font-heading font-bold text-2xl text-ink mb-3">Politique de confidentialité (RGPD)</h2>
          <p>En mode invité, seules les données minimales nécessaires à la réservation sont collectées (nom, email, téléphone, permis). Vous disposez d'un droit d'accès, de rectification et de suppression de vos données en écrivant à <a href={`mailto:${email}`} className="text-canard font-semibold">{email}</a>. Aucune donnée n'est revendue à des tiers. Le consentement cookies est requis pour les cookies non essentiels.</p>
        </div>
      </div>
    </div>
  );
}
